module.exports = __webpack_public_path__ + "img/04.f57c7f64.png";